import {MessageFilled, MessageOutlined} from '@ant-design/icons';
import {
    Button, Form,
    Input,
} from 'antd';
import {useForm} from 'antd/lib/form/Form';
import React, {FC, useState} from 'react';

import {ModalOpenerComponent} from 'components/modal-opener-component';
import {useAppDispatch} from 'store/config/hooks';

import {createAisCommentsRequestNd} from '../../../api/thunks';
import {ECommentRequestStatuses} from '../../../model/constants';
import {IAisRequestRowCommentTableDtoNd} from '../../../model/types';
import s from './ais-comment-request-row-modal-opener.module.less';

interface IAisCommentRequestRowModalOpenerProps {
  row: IAisRequestRowCommentTableDtoNd;
  fetchTableData: () => void;
  status: ECommentRequestStatuses;
}

export const AisCommentRequestRowModalOpener: FC<IAisCommentRequestRowModalOpenerProps> = ({
    row,
    fetchTableData,
    status,
}: IAisCommentRequestRowModalOpenerProps) => {
    const dispatch = useAppDispatch();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [form] = useForm<Partial<IAisRequestRowCommentTableDtoNd>>();

    const handleCancel = () => {
        setIsModalOpen(prev => !prev);
        form.resetFields();
    };

    const handleSave = async () => {
        const values = form.getFieldsValue();

        form.validateFields().then(async () => {
            if (form.isFieldsTouched()) {
                await dispatch(createAisCommentsRequestNd({
                    id: row.id,
                    comment: values.comment === '' ? undefined : values.comment,
                }));
                await fetchTableData();
            }

            handleCancel();
        });
    };

    return (
        <ModalOpenerComponent
            isOpen={isModalOpen}
            shouldConfirm={() => form.isFieldsTouched()}
            setIsOpen={setIsModalOpen}
            controlLabels={{
                save: 'Сохранить',
            }}
            hideControls={{
                save: status === ECommentRequestStatuses.COMPLETED,
            }}
            disabledControls={{
                save: status === ECommentRequestStatuses.COMPLETED,
            }}
            handleCancel={handleCancel}
            handleSave={handleSave}
            tooltip={{title: 'Комментарий'}}
            component={(
                <>
                    <Button
                        className={s['modal__comment-button']}
                        icon={!row?.comment ? <MessageOutlined /> : <MessageFilled />}
                        type="link"
                    />
                    <span>{row.itemNumber ?? ''}</span>
                </>
            )}
            modalProps={{
                title: 'Комментарий к строке',
                forceRender: true,
                destroyOnClose: false,
                centered: true,
                width: '980px',
            }}
        >
            <Form
                layout="vertical"
                form={form}
                initialValues={row}
            >
                <Form.Item
                    name="comment"
                >
                    <Input.TextArea
                        className={s['modal__text-area']}
                        placeholder="Введите комментарий"
                        disabled={status === ECommentRequestStatuses.COMPLETED}
                    />
                </Form.Item>
            </Form>
        </ModalOpenerComponent>
    );
};
